import { BasePrinterExecutor } from './BaseExecutor';

export class UnavailablePrinterExecutor extends BasePrinterExecutor {
  constructor(environment = 'web') {
    super({ type: 'unavailable', environment });
  }

  getCapabilities() {
    return {
      canDiscover: false,
      canPair: false,
      canPrint: false,
      transports: [],
      persistentConnection: false,
      notes: ['Printing is not available in this environment.'],
    };
  }
}




